import strFunc from "@/lib/lyg/string";

function ListArea(props: any) {
  let myProps = {
    xColumnArr: {},
    info_arr: [],
    ...props
  };
  let xColumnArr = myProps.xColumnArr;
  let info_arr = myProps.info_arr;

  const get_tr_list_tags = () => {
    let tr_tags: any = info_arr.map((info: any, idx: number) => {
      return (
        <tr key={idx}>
          {xColumnArr.x_column_list_arr.map((col: any, cidx: number) => {
            if (col.is_show === "1") {
              let reder_str = info[col.key];
              if (strFunc.is_empty(reder_str)) {
                reder_str = "-";
              }
              return <td key={cidx}>{reder_str}</td>;
            }
          })}
        </tr>
      );
    });
    return tr_tags;
  };

  return (
    <div>
      <div className="basic_list_div">
        <table>
          <colgroup>
            {xColumnArr.x_column_list_arr.map((col: any, idx: number) => {
              if (col.is_show === "1") {
                return <col key={idx} style={{ width: col.width + "px" }}></col>;
              }
            })}
          </colgroup>
          <thead>
            <tr>
              {xColumnArr.x_column_list_arr.map((col: any, idx: number) => {
                if (col.is_show === "1") {
                  return <th key={idx}>{col.name}</th>;
                }
              })}
            </tr>
          </thead>
          <tbody>
            {get_tr_list_tags()}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default ListArea;